import React from "react";
import { Box, IcoMoon, Text, TrackOrderIconWMO } from "@usap/uicomponents";
import styled from "styled-components";

const TrackOrderButton = ({ onClick }) => {
  const OrderDetailsTrackPackageCta = styled(Box)`
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 241px;
    height: 44px;
    border: 1px solid #3e3e47;
    border-radius: 4px;
    gap: 8px;
    cursor: pointer;
    padding: 4px;

    @media screen and (max-width: 992px) {
      width: 100%;
    }
  `;
  return (
    <OrderDetailsTrackPackageCta custom hideBorder onClick={onClick}>
      <IcoMoon
        icon={TrackOrderIconWMO}
        color="brand"
        size="20px"
        viewBoxProp="0 0 438.533 438.533"
      />
      <Text alignSelf="center" size="small" weight={600} color="border-2">
        Track Package
      </Text>
    </OrderDetailsTrackPackageCta>
  );
};

export default TrackOrderButton;
